<template>

<div class="section">

    <slot></slot>

</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.section {
    margin-bottom: 40px;
}

.section:last-child  {
    margin-bottom: 0px;
}

</style>
